/*
Copyright (c) 2021
*/

import constants from '../../constants';

const { REQUEST_ADDTIMEVIDEOQUESTION,ADDTIMEVIDEOQUESTION_RECEIVED } = constants.AddTimeVideoQuestionsConstant;

export default {
    REQUEST_ADDTIMEVIDEOQUESTION,
    ADDTIMEVIDEOQUESTION_RECEIVED,

  requestAddTimeVideoQuestion: payload => ({
    type: REQUEST_ADDTIMEVIDEOQUESTION,
    payload
  }),
  AddTimeVideoQuestionReceived: () => ({
    type: ADDTIMEVIDEOQUESTION_RECEIVED
  }),
};
